export default __webpack_public_path__ + "static/media/pbBleaum.c6a84f92.png";